import Cookies from "js-cookie";

const originalFetch = window.fetch;

window.fetch = async (input, init = {}) => {
  let role = Cookies.get("role");
  let url = "";

  if (typeof input === "string") {
    url = input;
  } else if (input instanceof Request) {
    url = input.url;
  }

  const isSameOrigin =
    url.startsWith("/") || url.includes(window.location.origin);

  const modifiedInit = {
    ...init,
    credentials: isSameOrigin ? "include" : init.credentials ?? "same-origin",
  };

  const response = await originalFetch(input, modifiedInit);

  if (response.status === 401) {
    const keys = Object.keys(Cookies.get());
    keys.forEach((k) => {
      Cookies.remove(k);
      Cookies.remove(k, { path: "/" });
    });
    localStorage.clear();
    sessionStorage.clear();

    if (role === "admin") {
      window.location.href = "/admin/login";
    } else {
      window.location.href = "/";
    }
  }

  return response;
};

export default function applyFetchInterceptor() {
  return true;
}
